import { lazy } from '@/service/lazy'

export default [{
  name: 'CampanhasInss',
  path: 'campanhainss',
  id: 'campanhainss',
  icon: 'fa fa-list',
  component: lazy('app/default/listagem/index'),
  meta: { requireAuth: true, rules: ['gerenciar_lista'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/listagemInss.js